import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="flex min-h-screen flex-col" data-id="element-92">
      <Header data-id="element-93" />
      <main className="flex-1" data-id="element-94">
        <Outlet data-id="element-95" />
      </main>
      <Footer data-id="element-96" />
    </div>;
}